import { render } from "./registration_request_sent.vue?vue&type=template&id=9400f0e2"
import script from "./registration_request_sent.js?vue&type=script&lang=js"
export * from "./registration_request_sent.js?vue&type=script&lang=js"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__